export default __webpack_public_path__ + "static/media/Armbands of Dark Terror.d4ba080d.jpg";